import {ImageColorSpace} from "@generated"
import {StateLabel} from "@platform/models/state-labels/state-label"

export const ImageColorSpaceLabels: Map<ImageColorSpace, StateLabel<ImageColorSpace>> = new Map<ImageColorSpace, StateLabel<ImageColorSpace>>([
    [ImageColorSpace.Srgb, {state: ImageColorSpace.Srgb, label: "sRGB"}],
    [ImageColorSpace.Linear, {state: ImageColorSpace.Linear, label: "Linear"}],
])
